import React from 'react';
import OpenPortalButton from './OpenPortalButton';
import ringArt from '../../assets/img/portal-ring.png';

/**
 * The stack in a card cover's top-right corner: OPEN A PORTAL on top (owner's order), share
 * under it.
 *
 * Share is a ring too now (share-sheet handoff §1): the Portal swirl, still — only the Portal
 * button spins, so the pair reads as a pair with one of them live — round a white face holding
 * a black glyph, inverting on hover. White reads on any poster, so there's no corner-tone logic
 * and no scrim. `onShare(rect)` gets the button's screen rect, which the sheet's burst flies
 * out of.
 */
const SHARE = (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="square" strokeLinejoin="miter" aria-hidden="true">
    <path d="M12 3v12M7 8l5-5 5 5M5 13v8h14v-8" />
  </svg>
);

export default function CoverActions({ event, onShare, portal = null }) {
  return (
    <div className="absolute right-3 top-3 z-[1] flex flex-col items-end gap-2.5">
      <OpenPortalButton event={event} portal={portal} />
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onShare(e.currentTarget.getBoundingClientRect()); }}
        aria-label="Share"
        className="group relative h-11 w-11 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2"
        data-testid="share-ring"
      >
        <span aria-hidden className="absolute inset-0 rounded-full" style={{ backgroundImage: `url(${ringArt})`, backgroundSize: 'cover' }} />
        <span aria-hidden className="absolute flex items-center justify-center rounded-full bg-white text-black transition-colors duration-200 group-hover:bg-black group-hover:text-white group-focus-visible:bg-black group-focus-visible:text-white" style={{ inset: 3 }}>
          {SHARE}
        </span>
      </button>
    </div>
  );
}
